import type { IMasterDataProductRepository } from "@src/domain/repositories/masterData";
import type { GetMasterDataProductsDTO } from "@src/domain/dto/masterData";

export class GetMasterDataProductsUseCase {
  private readonly repository: IMasterDataProductRepository;

  constructor(repository: IMasterDataProductRepository) {
    this.repository = repository;
  }

  execute(params: GetMasterDataProductsDTO) {
    return this.repository.getProducts(params);
  }
}
